import styled from "styled-components"
import { Row, Col, Accordion } from "react-bootstrap";
import { BPSAccordionStyled } from "../styled/BPSAccordion";

import DetailedReporting from '../../assets/images/Rebates - Detailed Analytics.png';
import EfficientValidation from '../../assets/images/Rebates - Pending Claims.png';
import Security from '../../assets/images/Rebates - Top Security.png';
import Communication from '../../assets/images/Rebates - Engaging Communication.png';

import { BPSCheckmarkList, Checkmark } from "../styled/Lists";
import { BPSArrowLink, Arrow } from "../styled/Buttons";


const EbikeAccordion = () => {
    return (
        <BPSAccordionStyled>
            <Accordion defaultActiveKey="0" >
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Quick & affordable setup</Accordion.Header>
                    <Accordion.Body>
                        <BPSCheckmarkList>
                            <ul>
                                <li>
                                    <Checkmark />Have your program up and running in under 90 days.
                                </li>
                                <li>
                                    <Checkmark />Enjoy transparent, budget-friendly pricing.
                                </li>
                            </ul>
                        </BPSCheckmarkList>
                        {/* <BPSArrowLink href="#">See our pricing <Arrow /></BPSArrowLink> */}
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                    <Accordion.Header>Incentives & payments made easy</Accordion.Header>
                    <Accordion.Body>
                        <BPSCheckmarkList>
                            <ul>
                                <li>
                                    <Checkmark />Choose from diverse payout options, including Visa Rewards, ACH, and checks.
                                </li>
                                <li>
                                    <Checkmark />Optimize your program with custom-branding and automation.
                                </li>
                            </ul>
                        </BPSCheckmarkList>
                        {/* <BPSArrowLink href="#">Review our incentive options <Arrow /></BPSArrowLink> */}
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                    <Accordion.Header>Top-tier security & validation</Accordion.Header>
                    <Accordion.Body>
                        <BPSCheckmarkList>
                            <ul>
                                <li>
                                    <Checkmark />Rest easy with our state-of-the-art security with swift and precise claims validation.
                                </li>
                                <li>
                                    <Checkmark />Enjoy advanced participant data protection, including two-factor authentication.
                                </li>
                            </ul>
                        </BPSCheckmarkList>
                        <BPSArrowLink href="/technology">Learn more about security & validation <Arrow /></BPSArrowLink>
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                    <Accordion.Header>Resources & customer support</Accordion.Header>
                    <Accordion.Body>
                        <BPSCheckmarkList>
                            <ul>
                                <li>
                                    <Checkmark />Rely on our friendly, expert customer service representatives.
                                </li>
                                <li>
                                    <Checkmark />Access a range of available resources and frequently asked questions.
                                </li>
                            </ul>
                        </BPSCheckmarkList>
                        <BPSArrowLink href="/support-services">Meet our customer service team <Arrow /></BPSArrowLink>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </BPSAccordionStyled>
    );
}


export { EbikeAccordion }
